// import * as App from "./../auw-main";

// App.run();

"use strict";
const ext = "./web/typo3conf/ext";
import "./App.scss";

import './../../Shared/Js/shared.js';
import './../Js/project';